import { useEffect, useRef, useState } from 'react'
import { Empty, Typography } from 'antd'
import { highlightQuoteInElement } from '../lib/domQuoteHighlight'
import './DocQuoteHighlightViewer.css'

type DocQuoteHighlightViewerProps = {
  html: string
  quote?: string | null
  minHeight?: string
}

export function DocQuoteHighlightViewer({
  html,
  quote = null,
  minHeight = 'calc(100vh - 400px)',
}: DocQuoteHighlightViewerProps) {
  const rootRef = useRef<HTMLDivElement>(null)
  const [matched, setMatched] = useState(false)

  useEffect(() => {
    const root = rootRef.current
    if (!root || !html.trim()) {
      setMatched(false)
      return
    }
    root.innerHTML = html
    const ok = highlightQuoteInElement(root, quote)
    setMatched(ok)
  }, [html, quote])

  if (!html.trim()) {
    return <Empty description="Word 文档内容为空" />
  }

  return (
    <div className="doc-quote-viewer" style={{ minHeight }}>
      <div ref={rootRef} className="doc-quote-viewer-inner kb-file-preview-docx" />
      {quote?.trim() ? (
        matched ? (
          <Typography.Text type="secondary" className="doc-quote-viewer-tip">
            已在 Word 原文中标红并选中定位内容
          </Typography.Text>
        ) : (
          <Typography.Text type="warning" className="doc-quote-viewer-tip">
            未在 Word 预览中匹配到引用原文，请对照上方引用句手动查找
          </Typography.Text>
        )
      ) : null}
    </div>
  )
}
